import { jsx, Fragment } from "react/jsx-runtime";
import { createElement } from "react";
import { Component } from "./Component.js";
import { Entity } from "./Entity.js";
const EntityList = Component(
  (props) => {
    if ("listComponent" in props && props.listComponent) {
      return createElement(props.listComponent, {
        ...props.listProps,
        accessor: props.accessor,
        children: props.children
      });
    }
    return /* @__PURE__ */ jsx(Fragment, { children: Array.from(props.accessor, (entity) => {
      return /* @__PURE__ */ jsx(Entity, { accessor: entity, children: props.children }, entity.key);
    }) });
  },
  (props) => {
    if ("listComponent" in props && props.listComponent) {
      return createElement(props.listComponent, {
        ...props.listProps,
        accessor: void 0,
        children: props.children
      });
    }
    return /* @__PURE__ */ jsx(Fragment, { children: props.children });
  },
  "EntityList"
);
export {
  EntityList
};
//# sourceMappingURL=EntityList.js.map
